// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f261a048","455":"6bf1a8e0","977":"897d696e"}[chunkId] + ".chunk.js";
};